export const SITE_NAMES = {
  AndersenWindows: 'AndersenWindows',
  RenewalbyAndersen: 'RenewalbyAndersen',
  RenewalbyAndersenCA: 'RenewalbyAndersenCA',
  OnlineScheduling: 'OnlineScheduling',
};
